import React from 'react';
import { ISonURL } from '../../../types/IUrl';
import { Hyperlink } from '../../../components/atoms/Hyperlink';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export type PageMembershipMatchingRulesSiteMapBaseElement = {
  id: string;
  link: ISonURL;
  matchingAttributes?: string[];
};
export type PageMembershipMatchingRulesSiteMapElement = PageMembershipMatchingRulesSiteMapBaseElement & {
  children?: PageMembershipMatchingRulesSiteMapElement[];
};

type PageMembershipMatchingRulesProps = { elements: PageMembershipMatchingRulesSiteMapElement[] | undefined };

export function SiteMap({ elements }: PageMembershipMatchingRulesProps) {
  const { t } = useSonTranslation('PageMembershipMatchingRuleList');

  if (!elements || elements.length === 0) {
    return null;
  }

  return (
    <ol className="page-membership-matching-rule-list__site-map-ol">
      {elements.map(element => {
        const hasMatchingAttributes = element.matchingAttributes && element.matchingAttributes.length > 0;

        return (
          <li key={element.id} className="page-membership-matching-rule-list__site-map-li">
            <Hyperlink
              to={element.link.url}
              className={`global--anchor ${hasMatchingAttributes ? 'font-bold-15-21' : 'font-regular-15-21'}`}
            >
              {element.link.name}
            </Hyperlink>
            {hasMatchingAttributes ? (
              <p className="page-membership-matching-rule-list__matching-attributes font-bold-15-21">
                <dfn className="page-membership-matching-rule-list__dfn invisible">{t('matchingRules')}</dfn>
                <span aria-hidden="true"> [</span>
                {element?.matchingAttributes?.join(' / ')}
                <span aria-hidden="true">]</span>
              </p>
            ) : null}
            {element.children && element.children.length > 0 ? <SiteMap elements={element.children} /> : null}
          </li>
        );
      })}
    </ol>
  );
}
